import { CLOSE_MODAL } from "../../store/actions/ActionConstant";
import { TOGGLE_MODAL } from "../../store/actions/ActionConstant";
import { OPEN_MODAL } from "../../store/actions/ActionConstant";
import {
  HIDE_USER_OTP_MODAL,
  SHOW_USER_OTP_MODAL,
  TOGGLE_USER_OTP_MODAL,
  HIDE_USER_UNVERIFIED_MODAL,
  SHOW_USER_UNVERIFIED_MODAL,
  TOGGLE_USER_UNVERIFIED_MODAL,
  HIDE_LIVE_STREAMING_PAYMENT_DIALOG,
  SHOW_LIVE_STREAMING_PAYMENT_DIALOG,
  HIDE_PERFORMER_PROFILE_PICTURE_MISSING_MODAL,
  SHOW_PERFORMER_PROFILE_PICTURE_MISSING_MODAL,
  TOGGLE_PERFORMER_PROFILE_PICTURE_MISSING_MODAL,
  HIDE_CARD_ADDRESS_MISMATCH_MODAL,
  SHOW_CARD_ADDRESS_MISMATCH_MODAL,
  TOGGLE_CARD_ADDRESS_MISMATCH_MODAL,
  HIDE_CARD_MANUAL_REVIEW_REQUIRED_MODAL,
  SHOW_CARD_MANUAL_REVIEW_REQUIRED_MODAL,
  TOGGLE_CARD_MANUAL_REVIEW_REQUIRED_MODAL,
} from "../actions/ActionConstant";

const initialState = {
  unverifiedPerformerModal: {
    show: false,
  },
  performerMissingProfilePicture: {
    show: false,
  },
  userOTPModal: {
    show: false,
    email: null,
    password: null,
  },
  general: {
    type: null,
    data: null,
    open: false,
  },
  liveStreamingPaymentModal: {
    show: false,
    channel: null
  },
  cardAddressMismatchModel: {
    show: false,
    errorMessage: null
  },
  cardManualReviewRequiredModel: {
    show: false,
  },
};

const ModelReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_USER_UNVERIFIED_MODAL:
      return {
        ...state,
        unverifiedPerformerModal: {
          show: !state.unverifiedPerformerModal.show,
        },
      };
    case HIDE_USER_UNVERIFIED_MODAL:
      return {
        ...state,
        unverifiedPerformerModal: {
          show: false,
        },
      };
    case SHOW_USER_UNVERIFIED_MODAL:
      return {
        ...state,
        unverifiedPerformerModal: {
          show: true,
        },
      };
    case TOGGLE_PERFORMER_PROFILE_PICTURE_MISSING_MODAL:
      return {
        ...state,
        performerMissingProfilePicture: {
          show: !state.performerMissingProfilePicture.show,
        },
      };
    case HIDE_PERFORMER_PROFILE_PICTURE_MISSING_MODAL:
      return {
        ...state,
        performerMissingProfilePicture: {
          show: false,
        },
      };
    case SHOW_PERFORMER_PROFILE_PICTURE_MISSING_MODAL:
      return {
        ...state,
        performerMissingProfilePicture: {
          show: true,
        },
      };
    case TOGGLE_USER_OTP_MODAL:
      return {
        ...state,
        userOTPModal: {
          ...action.data,
          show: !state.userOTPModal.show,
        },
      };
    case HIDE_USER_OTP_MODAL:
      return {
        ...state,
        userOTPModal: {
          ...action.data,
          show: false,
        },
      };
    case SHOW_USER_OTP_MODAL:
      return {
        ...state,
        userOTPModal: {
          ...action.data,
          show: true,
        },
      };
    case OPEN_MODAL:
      return {
        ...state,
        general: {
          type: action.data.type,
          data: action.data.data,
          open: true,
        },
      };
    case CLOSE_MODAL:
      return {
        ...state,
        general: {
          type: null,
          data: null,
          open: false,
        },
      };
    case TOGGLE_MODAL:
      return {
        ...state,
        general: {
          type: state.general.open ? null : action.data.type,
          data: state.general.open ? null : action.data.data,
          open: !state.general.open,
        },
      };
    case HIDE_LIVE_STREAMING_PAYMENT_DIALOG:
      return {
        ...state,
        liveStreamingPaymentModal: {
          show: false,
          channel: null
        },
      };
    case SHOW_LIVE_STREAMING_PAYMENT_DIALOG:
      return {
        ...state,
        liveStreamingPaymentModal: {
          show: true,
          channel: action.data
        }
      };
    case TOGGLE_CARD_ADDRESS_MISMATCH_MODAL:
      return {
        ...state,
        cardAddressMismatchModel: {
          show: !state.cardAddressMismatchModel.show,
        },
      };
    case HIDE_CARD_ADDRESS_MISMATCH_MODAL:
      return {
        ...state,
        cardAddressMismatchModel: {
          show: false,
        },
      };
    case SHOW_CARD_ADDRESS_MISMATCH_MODAL:
      return {
        ...state,
        cardAddressMismatchModel: {
          show: true,
          errorMessage: action.data.message
        },
      };
    case TOGGLE_CARD_MANUAL_REVIEW_REQUIRED_MODAL:
      return {
        ...state,
        cardManualReviewRequiredModel: {
          show: !state.cardManualReviewRequiredModel.show,
        },
      };
    case HIDE_CARD_MANUAL_REVIEW_REQUIRED_MODAL:
      return {
        ...state,
        cardManualReviewRequiredModel: {
          show: false,
        },
      };
    case SHOW_CARD_MANUAL_REVIEW_REQUIRED_MODAL:
      return {
        ...state,
        cardManualReviewRequiredModel: {
          show: true,
        },
      };
    default:
      return state;
  }
};

export default ModelReducer;
